const { padEnd } = require("lodash-es");

window.addEventListener('load', function () {
    let selectedIndex = 0;
    let myPageLeftPaneNavClass = '.left-pane nav ul li label';
    let myPageMobileContainerClass = '.tab__content-container label.tab__header';
    let myPageLeftNavLi = document.querySelectorAll(myPageLeftPaneNavClass);
    let myPageMobileContainerLabel = document.querySelectorAll(myPageMobileContainerClass);
    let activeIframeEl = null;

    // Prevent faulty dragging-slide-bug
    document.addEventListener('click', function (event) {
        // If the clicked element is a buy button then prevent default click event (REACT takes over from here)
        if (event.target.matches('.product__buy-button')) {
            event.preventDefault();
        };
    }, false);

    const onlineCatalogMenu = document.querySelector(".online-catalog > aside");
    if (onlineCatalogMenu) {
        onlineCatalogMenu.onclick = function () {
            onlineCatalogMenu.classList.toggle('active');
        }
    }

    // MyPages
    if (myPageLeftNavLi) {
        for (let i = 0; i < myPageLeftNavLi.length; i++) {
            myPageLeftNavLi[i].addEventListener('click', toggleMyPagesNav);
        }

        if (myPageMobileContainerLabel) {
            for (let i = 0; i < myPageMobileContainerLabel.length; i++) {
                myPageMobileContainerLabel[i].addEventListener('click', toggleMyPagesNavMobile);
            }
        }

        // MyPages
        // Set active tab
        function toggleMyPagesNav() {
            for (let i = 0; i < myPageLeftNavLi.length; i++) {
                let el = myPageLeftNavLi[i];
                el.classList.remove('active');
                if (el === event.target) {
                    selectedIndex = i;
                    loadIframe(selectedIndex);
                }
            }
            event.target.classList.add("active");
        }

        function toggleMyPagesNavMobile(event) {

            for (let i = 0; i < myPageMobileContainerLabel.length; i++) {
                let el = myPageMobileContainerLabel[i];
                el.classList.remove('active');
                if (el === event.target) {

                    selectedIndex = i;
                    loadIframe(selectedIndex);
                }
            }
            event.target.classList.add("active");
        }

        function loadIframe(index) {
            let tabContent = document.querySelectorAll('.tab__content-container .tab__content');
            if (tabContent && tabContent.length >= (index + 1)) {
                const el = tabContent[index];

                // MyPages
                // Check if tab content contains of an iframe
                const iframeEls = el.querySelectorAll('.iframe-holder');
                if (iframeEls) {
                    for (let i = 0; i < iframeEls.length; i++) {
                        let iframeWrapperEl = iframeEls[i];

                        // Check if iframe has attribute data-src
                        let iframeSrc = iframeWrapperEl.dataset.src;

                        if (iframeSrc) {
                            const iframeEl = document.createElement("iframe");
                            let loaderEl = document.createElement("div");
                            const parentEl = iframeWrapperEl.parentNode;

                            // Add loader
                            loaderEl.classList.add('generic-loader');
                            loaderEl.classList.add('for-iframe');
                            loaderEl.classList.add('active');
                            parentEl.appendChild(loaderEl);

                            let elWidth = iframeWrapperEl.dataset.width;
                            let elHeight = iframeWrapperEl.dataset.height;
                            if (!elWidth) {
                                elWidth = '100%';
                            }
                            if (!elHeight) {
                                elHeight = '800';
                            }

                            iframeEl.setAttribute('width', elWidth);
                            iframeEl.setAttribute('height', elHeight);
                            iframeEl.setAttribute('frameBorder', '0');
                            iframeEl.setAttribute('class', 'loading');

                            iframeEl.onload = function () {
                                iframeEl.classList.remove('loading');
                                if (loaderEl) {
                                    loaderEl.remove();
                                }
                                iframeEl.contentWindow.document.querySelectorAll('.pagination__link').forEach(item => {
                                    item.addEventListener("click", function (event) {
                                        if (loaderEl) {
                                            loaderEl.remove();
                                        }
                                        loaderEl = document.createElement("div");
                                        loaderEl.classList.add('generic-loader');
                                        loaderEl.classList.add('for-iframe');
                                        loaderEl.classList.add('active');
                                        parentEl.appendChild(loaderEl);
                                    });
                                });
                            };

                            iframeEl.onerror = function () {
                                console.log("Something wrong happened");
                            };

                            iframeEl.src = iframeSrc;



                            parentEl.replaceChild(iframeEl, iframeWrapperEl);
                        }
                    }
                }
            }
        }

        // MyPages
        // Load ev iframe on load
        var myPageTabRadioClass = '.my-mage__tabs .tab__radio';
        var myPageCheckboxes = document.querySelectorAll(myPageTabRadioClass);
        if (myPageCheckboxes) {
            for (var i = 0; i < myPageCheckboxes.length; i++) {
                var radioEl = myPageCheckboxes[i];
                if (radioEl.checked) {
                    loadIframe(i);
                }
            }
        }
    }

    let inventoryListToggle = document.getElementById('inventory-list-toggle');
    let inventoryListArrow = document.getElementById('inventory-list-arrow');
    if (inventoryListToggle) {
        inventoryListToggle.addEventListener('click', toggleInventoryList);

        function toggleInventoryList(event) {
            let inventoryList = document.getElementById('inventory-list');
            if (inventoryList.classList.contains('product__instock-inventory-list--hidden')) {
                inventoryList.classList.remove('product__instock-inventory-list--hidden');
                inventoryListArrow.className = 'arrow-up';
            }
            else {
                inventoryList.classList.add('product__instock-inventory-list--hidden');
                inventoryListArrow.className = 'arrow-down';
            }
        }
    }
});

